import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';

// Types
export interface ConfigTaxaConveniencia {
  id: string;
  pixPercentual: number | null;
  pixValorFixo: number | null;
  cartaoPercentual: number | null;
  cartaoValorFixo: number | null;
  criadoEm?: string | null;
  atualizadoEm?: string | null;
}

export interface ConfigTaxaConvenienciaInput {
  pixPercentual: number | null;
  pixValorFixo: number | null;
  cartaoPercentual: number | null;
  cartaoValorFixo: number | null;
}

// Fragment (to keep fields consistent)
const CONFIG_TAXA_FIELDS = gql`
  fragment ConfigTaxaConvenienciaFields on ConfigTaxaConveniencia {
    id
    pixPercentual
    pixValorFixo
    cartaoPercentual
    cartaoValorFixo
    criadoEm
    atualizadoEm
  }
`;

// Query
export const CONFIG_TAXA_CONVENIENCIA_QUERY = gql`
  ${CONFIG_TAXA_FIELDS}
  query ConfigTaxaConveniencia {
    configTaxaConveniencia {
      ...ConfigTaxaConvenienciaFields
    }
  }
`;

// Mutation
export const SALVAR_CONFIG_TAXA_CONVENIENCIA = gql`
  ${CONFIG_TAXA_FIELDS}
  mutation SalvarConfigTaxaConveniencia($input: ConfigTaxaConvenienciaInput!) {
    salvarConfigTaxaConveniencia(input: $input) {
      ...ConfigTaxaConvenienciaFields
    }
  }
`;

// Service API — espelha ConfigTaxaConvenienciaGraphQL.java (service.obter()/service.salvar())
export async function obter(): Promise<ConfigTaxaConveniencia | null> {
  const { data } = await apolloClient.query<{ configTaxaConveniencia: ConfigTaxaConveniencia | null }>({
    query: CONFIG_TAXA_CONVENIENCIA_QUERY,
    fetchPolicy: 'no-cache',
  });
  return data?.configTaxaConveniencia ?? null;
}

export async function salvar(input: ConfigTaxaConvenienciaInput): Promise<ConfigTaxaConveniencia> {
  const { data } = await apolloClient.mutate<
    { salvarConfigTaxaConveniencia: ConfigTaxaConveniencia },
    { input: ConfigTaxaConvenienciaInput }
  >({
    mutation: SALVAR_CONFIG_TAXA_CONVENIENCIA,
    variables: { input },
  });
  if (!data?.salvarConfigTaxaConveniencia) {
    throw new Error('Falha ao salvar a taxa de conveniência.');
  }
  return data.salvarConfigTaxaConveniencia;
}
